<template>
  <div>
    <aside
      class="sticky top-24 h-[calc(100vh-theme(spacing.48))] pb-28 md:ml-4 pr-5 border-r-2 border-color-iron overflow-y-auto"
    >
      <h1 class="text-2xl mb-6 font-bold text-oxford-blue">{{ translate('filters', 'ucfirst') }}</h1>
      <div class="mb-5">
        <h1 class="mb-3 font-semibold text-lg text-oxford-blue">{{ translate('sector', 'ucfirst') }}</h1>
        <ul class="flex flex-col gap-2">
          <li
            v-for="(type, index) in types"
            :key="index"
            class="flex align-items-center gap-3"
          >
            <input type="checkbox" v-model="selected.types" :id="type.id" :value="type.id" />
            <label :for="type.id">{{ type.name }}</label>
          </li>
        </ul>
      </div> 
      <div class="mb-5">
        <h1 class="mb-3 font-semibold text-lg text-oxford-blue">{{ translate('skills', 'ucfirst') }}</h1>
        <ul class="flex flex-col gap-2">
          <li
            v-for="(seniority, index) in seniorities"
            :key="index"
            class="flex align-items-center gap-3"
          >
            <input type="checkbox"
              v-model="selected.seniorities"
              :id="seniority.id"
              :value="seniority.id"  class="w-4 border-1 border-gray-200"
            />
            <label :for="seniority.id">{{ seniority.name }}</label>
          </li>
        </ul>
      </div>
    </aside>
  </div>
</template>

<script setup>
import { reactive, watch } from "vue"; 
import { translate } from "@/composables/translate";

// ############ Emits e Props ############

const emit = defineEmits(["filters", "filterBySalary"]);

// ############ Declaração de variáveis ############

const selected = reactive({
  types: [],
  seniorities: []
});

const types = reactive([
  { name: "BDA", id: "FT" },
  { name: "E. Software", id: "PT" },
  { name: "A. de dados", id: "RT" },
  { name: "Computação", id: "CT" },
  { name: "Marketing", id: "TT" },
]);

const seniorities = reactive([
  { name: "Marketing Digital", id: "st" },
  { name: "Javascript", id: "jn" },
  { name: "Web Design", id: "md" },
  { name: "Laravel", id: "sn" },
  { name: "BDA", id: "dt" },
]);


// ############ Watch ############

watch(
  () => selected,
  () => {
    emit("filters", selected);
  },
  { deep: true }
);

</script>

<style scoped></style>
